import { getDomainCfg } from "../../core/state";
import { isUserLoggedIn } from "../cloudstorage/cloud";
import { getJson } from "../http";
import { AchievementResponse, LoggedEvent } from "./types";

export async function logEvent(eventData: LoggedEvent): Promise<any> {  
  const baseUrl = getDomainCfg().serverSettings.baseUrl;
  const request = new Request(`${baseUrl}/wp-json/events/v1/log`, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(eventData),
      redirect: 'follow',
      mode : 'cors',
      credentials: 'include'
  });

  const response = await getJson(request);
  return response.status === "success";
}

export async function evaluateAchievements(): Promise<any> {
  const baseUrl = getDomainCfg().serverSettings.baseUrl;
  const request = new Request(`${baseUrl}/wp-json/wp-event-logger/v1/evaluate-achievements/`, {
      method: 'POST',
      redirect: 'follow',
      mode : 'cors',
      credentials: 'include'
  });

  try {
      const response = await fetch(request);
      const data = await response.json();

      if (!response.ok) {
        console.log("Fehler beim Auswerten der Achievements:", data);
        throw new Error(data.message || "Unknown error");
    }

    // Wenn neue Achievements vorhanden sind, geben Sie die IDs zurück, sonst ein leeres Array
    return data.new_achievements || [];
  } catch (error) {
      console.error("Network error:", error);
      return { error: "Network error" };
  }
}


export async function getAchievements(): Promise<AchievementResponse[]> {
  const baseUrl = getDomainCfg().serverSettings.baseUrl;
  const request = new Request(`${baseUrl}/wp-json/wp-event-logger/v1/achievements/`, {
      method: 'GET',
      redirect: 'follow',
      mode : 'cors',
      credentials: 'include'
  });

  try {
      const response = await fetch(request);
      const data: AchievementResponse[] = await response.json();

      if (!response.ok) {
          console.log("Fehler beim Abrufen der Achievements:", data);
          throw new Error(data.map(a => a.description).join(", ") || "Unknown error");
      }

      return data;
  } catch (error) {
      console.error("Network error:", error);
      throw error;  // Fehler weitergeben, damit er von aufrufenden Funktionen behandelt werden kann
  }
}


